<template>
  <div class="footer1">
    <div class="footer">
      <div class="footer_top">
        <div class="footerdiv">
          <!-- <p>中国新闻文化促进会主办</p> -->
          <p>
            主办单位：中国新闻文化促进会 &nbsp; &nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地址：
            北京市东城区北新桥三条1号院
          </p>
          <p>
            电话（传真）： 010-84083148&nbsp; &nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮箱：
            cmcpa1991@163.com
          </p>
          <!-- <p>中国新闻文化促进会版权所有，未经授权禁止复制或建立镜像</p> -->

          <p >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a  style="color:#fff;" href="https://beian.miit.gov.cn/">京ICP备2021036886号-1</a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102005830"
            style="
              display: inline-block;
              text-decoration: none;
              height: 20px;
              line-height: 20px;
              color:#fff;
            "
            ><img src="../../../../static/ga.png" style="float: left" /> 京公网安备 11010102005830号
           </a
          >
          </p>
        </div>
      </div>
      <div class="footer_foot">
        <div class="gotBtnBomdiv">
          <p style="font-size: 14px; color: #f5f5f5">
            Copyright @ 2009-2015 All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router/index";
import axios from "axios";
export default {
  data() {
    return {
      clickcount: "",
      options: [],
      value: "",
    };
  },
  methods: {
    toMenu(url) {
      this.$router.push({
        path: url,
      });
    },
    getData() {
      axios
        .post("/FriendlyLinkAPI/GetList", {
          ChannelID: 2468,
          JournalID: 202007100001,
        })
        .then((res) => {
          this.options = res.data; //_itemList是上面那个结构体
        });
    },
    getcount() {
      axios
        .post("/SiteConfigWebAPI/GetSiteAccessCount", {
          JournalID: 202007100001,
        })
        .then((res) => {
          this.clickcount = res.data.data;
        });
    },
    toMenu(url) {
      window.open(url);
    },
  },
  created() {
    this.getData();
    this.getcount();
  },
};
</script>

<style lang="less" scoped>
.footer1 {
  // width: 1200px;
  height: auto;
  margin: 0 auto;
  // margin-top: 41px;
}
.footer {
  width: 100%;
  height: auto;
  margin-top: 35px;

  .footer_top {
    width: 100%;
    height: 195px;
    background-color: #c01b22;
    margin: 0 auto;
    .footerdiv {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding-top: 23px;
      // margin-left: 870px;
      text-align: center;
      position: relative;
      background-color: #c01b22;
      p {
        // letter-spacing: 2px;
        text-align: left;
        font-size: 14px;
        color: #f5f5f5;
        margin: 0 auto;
        line-height: 29px;
        margin-left: 345px;
        position: relative;
        top: 20px;
        // text-align-last: justify;
      }
    }
  }
  .footer_foot {
    width: 100%;
    margin: 0 auto;
    height: 43px;
    background-color: #aa0d14;
    .gotBtnBomdiv {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      font-size: 14px;
      background-color: #aa0d14;
      font-family: "SourceHanSansSC-Regular";
      font-weight: 400;
      color: #f5f5f5;
      line-height: 43px;
      text-align: center;
      p {
        height: 100%;
      }
    }
  }
}
/deep/.el-select-dropdown__item {
  color: #606266 !important;
}
/deep/.el-select-dropdown__item.selected {
  color: #606266 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/foot/index.vue